// =============================================================================
// navigation/linking.ts — react-navigation deep-link config (blueprint §2).
//
// Replaces expo-router's file-route deep linking + the push-tap relative-path
// whitelist. `cryb://` scheme is declared in Info.plist (CFBundleURLTypes) and
// forwarded by AppDelegate's RCTLinkingManager overrides. The push-tap router
// (P3-8 / P4) maps notification payload paths onto these same route names.
// =============================================================================
import type { LinkingOptions } from '@react-navigation/native';
import type { RootStackParamList } from './types';

export const linking: LinkingOptions<RootStackParamList> = {
  prefixes: ['cryb://', 'https://cryb.ai', 'https://app.cryb.ai'],
  config: {
    screens: {
      // Auth deep links (P3 AUTH group). The password-reset email links to
      // cryb://reset-password?token=… → AuthStack ResetPassword (?token maps to
      // route.params.token). Only matched while the gate shows the Auth branch.
      Auth: {
        screens: {
          Login: 'login',
          Register: 'register',
          ForgotPassword: 'forgot-password',
          ResetPassword: 'reset-password',
        },
      },
      Tabs: {
        screens: {
          Home: 'home',
          Discover: 'discover',
          Learn: 'learn',
          Chat: 'chat',
          Profile: 'me',
        },
      },
      Post: 'post/:id',
      Community: 'community/:name',
      Communities: 'communities',
      UserProfile: 'user/:username',
      Channel: 'channel/:id',
      ServerDetail: 'servers/:id',
      ServersDiscover: 'servers/discover',
      DM: 'dm/:id',
      DMNew: 'dm/new',
      Notifications: 'notifications',
      Search: 'search',
      Wallet: 'wallet',
      Bookmarks: 'bookmarks',
      VoiceRooms: 'voice',
      VoiceRoom: 'voice/:id',
      // The Learn TAB (Tabs > Learn) owns the canonical `learn` path. This flat
      // root-stack Learn screen must use a DISTINCT pattern or react-navigation
      // linking throws "conflicting screens with the same pattern 'learn'" (fatal
      // on the web target, which validates path uniqueness at mount). `learn/index`
      // keeps it inside the learn namespace without colliding with the tab.
      LearnIndex: 'learn/index',
      LearnArticle: 'learn/:slug',
      NftMarketplace: 'nft/marketplace',
      NftDetail: 'nft/:id',
      Crypto: {
        path: 'crypto',
        screens: {
          Signal: 'signal/:id',
          Token: 'token/:symbol',
          Trader: 'trader/:id',
        },
      },
    },
  },
};
